<template>
<div>

<div class="modal-content border border-success">
<div  style="background-color:#9acd32;color:black" class="modal-header border border-success text-nowrap ">
  <h4 class="modal-title ">
    <i style="color:blue" class="fas fa-cash-register mr-3" aria-hidden="true"></i>     
    <strong>STAMPA SCONTRINO DI CORTESIA</strong>
  </h4>  
</div>


<div class="modal-footer">
    <button @click="$emit('close')" type="button" class="btn btn-secondary ">
      <i class="fas fa-reply mr-2" aria-hidden="true"></i>
        ANNULLA
    </button>

    <button  @click="getTxtFile()"  type="button" class="btn btn-primary ">
          <i class="fas fa-print mr-2" aria-hidden="true"></i>   
            STAMPA 
          
    </button>    
</div>

</div>

</div>

</template>

<script>

  export default {

  props : ['data'],
  
    data () {
      return {
          
          newLine  : '\r\n',
                                          
      }
    },

    
    methods: 
    {

     getTxtFile() 
     {
                          
        let txtFile                = "data:text/csv;charset=utf-8," 
        let data                   =  ''
        data = 'j' + this.newLine
        txtFile += data
        data = '"       SCONTRINO DI CORTESIA"1@' + this.newLine
        txtFile += data
        data  = '"' +  'S' + this.data.saleId + '"3B' +  this.newLine
        txtFile += data
        data = 'J' +  this.newLine
        txtFile += data
        
                        
            const encodedUri = encodeURI(txtFile);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "scontrino.txt");      
            link.click()
            this.$emit('close')
   
        
          }
    }
    
  }
</script>
<style scoped>
 
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.modal-footer {  
  justify-content: space-between;  
}
.modal-content
{
  width:  500px;
}

</style>
